export enum SuppressionStatus {
  INITIATED = 'initiated',
  IN_PROGRESS = 'in_progress',
  STOPPED = 'stopped',
  SUCCESS = 'success',
  FAILED = 'failed',
}
